/* eslint-disable camelcase, import/prefer-default-export */
import {
  createSelector,
} from 'reselect';
import {
  coreUtils,
  coreSelectors,
} from '@gymcloud/core';
import {
  DateTime,
} from 'luxon';
import {
  getUiState,
} from './ui';

export const getEventsForBigCalendar = userId => createSelector(
  [
    coreSelectors.getResourceMappedList('workoutEvents', userId || 'all'),
    getUiState('calendarSelectedUser'),
  ],
  events => events.map(event => ({
    ...event,
    title: event.workout_name,
    start: new Date(event.begins_at),
    end: new Date(event.ends_at || event.begins_at),
    startTime: DateTime.fromISO(event.begins_at).toFormat('t'),
    color: coreUtils.userColors[event.person_id % coreUtils.userColors.length],
  })),
);
